// extracted by mini-css-extract-plugin
export var copyIcon = "_rj-2";
export var discountCard = "_rj-0";
export var discountCode = "_rj-3";
export var discountContent = "_rj-1";
export var loadingCard = "_rj-4";